import { createFileRoute } from "@tanstack/react-router";
import { StickyHeader } from "@/components/site/StickyHeader";
import { Footer } from "@/components/site/Footer";
import { FadeIn } from "@/components/site/FadeIn";
import { EmailCaptureForm } from "@/components/site/EmailCaptureForm";

const CALENDLY = "https://calendly.com/katie-fernands/discovery-call";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Katie Fernands — Fractional Marketing Leadership" },
      {
        name: "description",
        content:
          "Get in touch about fractional marketing leadership for RIA firms, banks, and fintech advisory teams. Book a call or send a note.",
      },
      { property: "og:title", content: "Contact Katie Fernands" },
      {
        property: "og:description",
        content:
          "Fractional marketing leadership for RIA firms, banks, and fintech. Book a call or send a note.",
      },
      { property: "og:url", content: "https://katiefernands.com/contact" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://katiefernands.com/contact" }],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col">
      <StickyHeader />
      <main className="flex-1 pt-32 pb-24">
        <div className="mx-auto max-w-2xl px-6 lg:px-10">
          <FadeIn>
            <p className="text-xs uppercase tracking-[0.24em] text-primary mb-3">Contact</p>
            <h1 className="text-4xl md:text-5xl font-serif tracking-tight">
              Let's talk about your pipeline
            </h1>
            <p className="mt-5 text-foreground/70 text-lg leading-relaxed">
              Fractional marketing leadership for RIA firms, banks, and fintech advisory teams
              (4–20 employees). If growth has plateaued past the referral ceiling, that's the
              conversation to have.
            </p>
          </FadeIn>

          <FadeIn>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href={CALENDLY}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-medium hover:opacity-90 transition-opacity"
              >
                Book a 20-minute call →
              </a>
              <a
                href="mailto:katie@katiefernands.com"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-primary/30 text-primary px-6 py-3 text-sm font-medium hover:bg-primary/10 transition-colors"
              >
                katie@katiefernands.com
              </a>
            </div>
          </FadeIn>

          <FadeIn>
            <div className="mt-14">
              <EmailCaptureForm
                source="contact-page"
                variant="full"
                heading="Or send a note"
                subheading="Tell me a bit about your firm and what's stuck. I read and reply to every one."
                showName
                showMessage
                buttonLabel="Send"
                successMessage="Got it — I'll reply within a day."
              />
            </div>
          </FadeIn>
        </div>
      </main>
      <Footer />
    </div>
  );
}
